import React, { useState, useEffect } from "react";

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 20) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 z-50 w-full transition-all duration-300 ${
        isScrolled
          ? "backdrop-blur-md bg-black/80 border-b border-white/10"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className="layout-container h-16 flex items-center justify-between">
        {/* Muted Name on Left */}
        <a
          href="#home"
          className="text-xs md:text-sm font-mono tracking-widest text-zinc-400 hover:text-white uppercase transition-colors duration-300 font-medium select-none"
        >
          Rupak Boral
        </a>

        {/* Links on Right */}
        <nav className="flex items-center gap-4 sm:gap-6 md:gap-8">
          <a
            href="#about"
            className="text-xs md:text-sm font-mono tracking-wide text-zinc-300 hover:text-white transition-colors duration-300 select-none py-2"
          >
            About
          </a>
          <a
            href="#skills"
            className="text-xs md:text-sm font-mono tracking-wide text-zinc-300 hover:text-white transition-colors duration-300 select-none py-2"
          >
            Skills
          </a>
          <a
            href="#work"
            className="text-xs md:text-sm font-mono tracking-wide text-zinc-300 hover:text-white transition-colors duration-300 select-none py-2"
          >
            Work
          </a>
          <a
            href="#achievements"
            className="text-xs md:text-sm font-mono tracking-wide text-zinc-300 hover:text-white transition-colors duration-300 select-none py-2"
          >
            Awards
          </a>
          <a
            href="#contact"
            className="text-xs md:text-sm font-mono tracking-wide text-zinc-300 hover:text-white transition-colors duration-300 select-none py-2"
          >
            Contact
          </a>
        </nav>
      </div>
    </header>
  );
};

export default Header;
